// extracted by mini-css-extract-plugin
export default {"chevron":"ChevronRight_chevron__RXotX","active":"ChevronRight_active__Xc6aJ","wrapper":"ChevronRight_wrapper__clpcA"};